package kz.dentalcrm.app.screens.patients.add.mvi

import kz.dentalcrm.app.core.base.ViewEvent

sealed interface AddPatientViewEvent : ViewEvent {
    data class AddPatient(val name: String, val surname: String, val phone: String) : AddPatientViewEvent
}
